export const AccountRouteNames = {
  ModuleBase: 'account',

  Login: 'login',
  Register: 'register',
  ForgotPassword: 'forgot-password',
  UserProfile: 'user_profile',
  TwoFactor: 'two_factor',
  ResetPassword: 'reset_password',
};

export const CatalogRouteNames = {
  ModuleBase: 'catalog',
};

export const HomeRouteNames = {
  ModuleBase: 'home',
  Dashboard: 'dashboard',
};

export const SysLogRouteNames = {
  ModuleBase: 'syslog',
  Overview: '',
  Detail: 'detail',
};

export const AdminRouteNames = {
  ModuleBase: 'admin',
  AdminDashboard: '',
  RegisterList: 'register_list',
  Companies: 'companies',
  ProjectTracker: 'project_tracker',
  RequestTracker: 'request_tracker',
  FscaList: 'fsca_list',
  Blog: 'blog',
  Kpi: 'kpi',
  FeeList: 'fee_list',
  RateList: 'rate_list',
  DocumentConfig: 'document_config',
  WorkflowList: 'workflow_list',
  TaskList: 'task_list',
  Migrations: 'migrations',
  SysLog: SysLogRouteNames.ModuleBase,
};

// TODO: Old system
export const InvitationRouteNames = {
  ModuleBase: 'invitation-old',
  ModuleBaseTender: 'invitation-old-tender',
  Overview: '',
  Detail: 'detail',
  New: 'new',
};

export const TenderRouteNames = {
  ModuleBase: 'tender',
  TenderOid: 'id',
  ItemOid: 'itemOid',
  OfferOid: 'offerOid',
  Wizard: 'wizard',
  NewId: 'new',
  Cancel: 'cancel',
  RecallDecision: 'recall-decision',
  OfferOpening: 'offer-opening',
  OfferCleanUp: 'offer-clean',
  RequestApproval: 'request-approval',
  CollectiveSourcingComplete: 'collective-sourcing-complete',
  Publish: 'publish',
  CommunicateAward: 'communicate-award',
  Decide: 'decide',
  Rating: 'rating',
  DisqualifyOffer: 'disqualify-offer',
  Specification: 'specification',
  FinishProject: 'finish',
};

// wizard steps might change in the future depending tender (RFI, RFP etc.)
// this is a placeholder, it should be defined in backend
export enum TenderWizardSteps {
  BaseData = 'BaseData',
  Items = 'Items',
  CollectiveSourcing = 'CollectiveSourcing',
  Procedure = 'Procedure',
  ItemAttributes = 'ItemAttributes',
  VendorAttributes = 'VendorAttributes',
  VendorSelection = 'VendorSelection',
  Documents = 'Documents',
  Rating = 'Rating',
  Dates = 'Dates',
}

export const OfferRouteNames = {
  ModuleBase: 'offer',
  TenderOid: 'tenderOid',
  OfferOid: 'offerOid',
  Preview: 'preview',
  EditOffer: 'edit',
  SubmitOffer: 'submit',
  Public: 'public',
};

export const DemandRequestRouteNames = {
  ModuleBase: 'demand-request',
  Overview: '',
  Detail: 'detail',
  New: 'new',
};

export const ContractRouteNames = {
  ModuleBase: 'contract',
  ContractOid: 'contractOid',
  Detail: 'detail',
};
